import { AnyField, FieldType, ProductTag } from './types'
import { rangeOfFilterWeights } from './utils'

const sizePurchasedValues = [
  { name: 'XXS', value: 'XXS' },
  { name: 'XS', value: 'XS' },
  { name: 'S', value: 'S' },
  { name: 'M', value: 'M' },
  { name: 'L', value: 'L' },
  { name: 'XL', value: 'XL' },
  { name: '2XL', value: '2XL' },
  { name: '3XL', value: '3XL' },
  { name: '4XL', value: '4XL' },
  { name: '5XL', value: '5XL' },
  { name: '6XL', value: '6XL' },
]

const fitValues = [
  { name: 'Too Small', value: '1' },
  { name: 'Small', value: '2' },
  { name: 'True to Size', value: '3' },
  { name: 'Big', value: '4' },
  { name: 'Too Big', value: '5' },
]

const heightValues = [
  { name: `5'0 or less`, value: `5'0 or less` },
  { name: `5'1 - 5'3`, value: `5'1 - 5'3` },
  { name: `5'4 - 5'6`, value: `5'4 - 5'6` },
  { name: `5'7 - 5'9`, value: `5'7 - 5'9` },
  { name: `5'10 - 6'0`, value: `5'10 - 6'0` },
  { name: `6'1 - 6'3`, value: `6'1 - 6'3` },
  { name: `6'4 - 6'6`, value: `6'4 - 6'6` },
  { name: `6'7 or above`, value: `6'7 or above` },
]

const weightValues = [
  { name: 'Under 100 lbs', value: rangeOfFilterWeights(0, 100), min: 0, max: 100 },
  { name: '101 - 125 lbs', value: rangeOfFilterWeights(101, 125), min: 101, max: 125 },
  { name: '126 - 150 lbs', value: rangeOfFilterWeights(126, 150), min: 126, max: 150 },
  { name: '151 - 175 lbs', value: rangeOfFilterWeights(151, 175), min: 151, max: 175 },
  { name: '176 - 200 lbs', value: rangeOfFilterWeights(176, 200), min: 176, max: 200 },
  { name: '201 - 225 lbs', value: rangeOfFilterWeights(201, 225), min: 201, max: 225 },
  { name: '226 - 250 lbs', value: rangeOfFilterWeights(226, 250), min: 226, max: 250 },
  { name: 'Over 251 lbs', value: rangeOfFilterWeights(251, 500), min: 251, max: 500 },
]

const occupationValues = [
  { name: 'Dental', value: 'Dental' },
  { name: 'Nursing', value: 'Nursing' },
  { name: 'Physician', value: 'Physician' },
  { name: 'Specialize', value: 'Specialized Therapy' },
  { name: 'Student', value: 'Student' },
  { name: 'Teacher', value: 'Teacher' },
  { name: 'Tech', value: 'Tech' },
  { name: 'Veterinarian', value: 'Veterinarian' },
  { name: 'Other', value: 'Other' },
]

const mediaTypeValues = [
  { name: 'Show Reviews with Photos', value: 'photos' },
  // TODO: restore this option once we have the ability to determine
  // mediaType within the BE service.
  // { name: 'With Videos', value: 'videos' },
]

export const fieldsByTag: Record<ProductTag, AnyField[]> = {
  [ProductTag.Tops]: [
    {
      // Fake field id as this isn't a Yotpo custom field
      fieldId: -1,
      name: 'Photos',
      type: FieldType.MediaType,
      values: mediaTypeValues,
    },
    {
      fieldId: 48465,
      name: 'Size Purchased',
      type: FieldType.Size,
      values: sizePurchasedValues,
    },
    {
      fieldId: 48922,
      name: 'Fit',
      type: FieldType.Fit,
      values: fitValues,
    },
    {
      fieldId: 48892,
      name: 'Height',
      type: FieldType.Height,
      values: heightValues,
    },
    {
      fieldId: 48468,
      name: 'Weight',
      type: FieldType.Weight,
      values: weightValues,
    },
    {
      fieldId: 48469,
      name: 'Occupation',
      type: FieldType.Occupation,
      values: [
        { name: 'Dental', value: 'Dental' },
        { name: 'Nursing', value: 'Nursing' },
        { name: 'Physician', value: 'Physician' },
        { name: 'Specialize', value: 'Specialized Therapy' },
        { name: 'Student', value: 'Student' },
        { name: 'Teacher', value: 'Teacher' },
        { name: 'Tech', value: 'Tech' },
        // NOTE: this value must stay as `Vet`, not `Veterinarian.
        // Yotpo is set up with `Vet` as the filter value for Tops
        { name: 'Veterinarian', value: 'Vet' },
        { name: 'Other', value: 'Other' },
      ],
    },
  ],
  [ProductTag.Bottoms]: [
    {
      // Fake field id as this isn't a Yotpo custom field
      fieldId: -1,
      name: 'Photos',
      type: FieldType.MediaType,
      values: mediaTypeValues,
    },
    {
      fieldId: 48470,
      name: 'Size Purchased',
      type: FieldType.Size,
      values: sizePurchasedValues,
    },
    {
      fieldId: 48471,
      name: 'Length Purchased',
      type: FieldType.Length,
      values: [
        { name: 'Regular', value: 'Regular' },
        { name: 'Short', value: 'Short' },
        { name: 'Petite', value: 'Petite' },
        { name: 'Tall', value: 'Tall' },
      ],
    },
    {
      fieldId: 48921,
      name: 'Fit',
      type: FieldType.Fit,
      values: fitValues,
    },
    {
      fieldId: 48890,
      name: 'Height',
      type: FieldType.Height,
      values: heightValues,
    },
    {
      fieldId: 48474,
      name: 'Weight',
      type: FieldType.Weight,
      values: weightValues,
    },
    {
      fieldId: 48475,
      name: 'Occupation',
      type: FieldType.Occupation,
      values: occupationValues,
    },
  ],
  [ProductTag.Others]: [
    {
      // Fake field id as this isn't a Yotpo custom field
      fieldId: -1,
      name: 'Photos',
      type: FieldType.MediaType,
      values: mediaTypeValues,
    },
    {
      fieldId: 48476,
      name: 'Size Purchased',
      type: FieldType.Size,
      values: [
        { name: 'S/M', value: 'S/M' },
        { name: 'M/L', value: 'M/L' },
        { name: 'N/A', value: 'N/A' },
      ],
    },
    {
      fieldId: 48920,
      name: 'Fit',
      type: FieldType.Fit,
      values: fitValues,
    },
    {
      fieldId: 48891,
      name: 'Height',
      type: FieldType.Height,
      values: heightValues,
    },
    {
      fieldId: 48479,
      name: 'Weight',
      type: FieldType.Weight,
      values: weightValues,
    },
    {
      fieldId: 48480,
      name: 'Occupation',
      type: FieldType.Occupation,
      values: occupationValues,
    },
  ],
}

export const fieldsByFieldType = Object.entries(fieldsByTag).reduce<
  Record<ProductTag, { [x in FieldType]?: AnyField }>
>(
  (items, [key, fields]) => {
    items[key as ProductTag] = fields.reduce<{ [x in FieldType]?: AnyField }>((items, field) => {
      items[field.type] = field
      return items
    }, {})

    return items
  },
  {} as Record<ProductTag, { [x in FieldType]?: AnyField }>
)

export const fieldsByFieldId = Object.values(fieldsByTag).reduce<Record<number, AnyField>>(
  (items, fields) => {
    return fields.reduce((items, field) => {
      items[field.fieldId] = field
      return items
    }, items)
  },
  {}
)
